export default __webpack_public_path__ + "static/footer-shape-f49b373466da049f1283656ba8300040.png";